to_number = (x) => Number(x);

module.exports = { to_number };
